import React, { useState } from 'react';
import ReactPaginate from "react-paginate";
import { Link,useNavigate } from 'react-router-dom';
import VendorWithdrawServices from '../services/VendorWithdrawServices';
import useAsync from '../hooks/useAsync';
import Modal from 'react-modal';
import DeleteButton from './Button/DeleteButton';
import * as XLSX from 'xlsx';
import { FaRegEye } from "react-icons/fa";
Modal.setAppElement('#root');

function VendorApproveWithdrawList() {
  const { data, error, isLoading, run } = useAsync(VendorWithdrawServices.getApproveWithdrawList);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 20;
const navigate=useNavigate()
  const handleEditDetails = (withdraw) => {
    setSelectedEdit(withdraw);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };
  const handleViewDetails = (withdraw) => {
    const id = withdraw?._id || withdraw?.id;

    if (!id) {
      console.log("Withdrawal ID not found");
      return;
    }

    navigate(`/vendor-withdrawl-detail/${id}`);
  };
  const handleDelete = (withdraw) => {
    setSelectedEdit(withdraw);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };

  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  function formatDateTime(isoString) {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

const filteredData =
  data?.data?.filter((withdraw) => {
    const search = searchQuery.toLowerCase().trim();

    const customerName = (
      withdraw?.user_id?.name ||
      withdraw?.upi_name ||
      withdraw?.account_holder_name ||
      ""
    ).toLowerCase();

    const firstName = (
      withdraw?.user_id?.firstName || ""
    ).toLowerCase();

    const lastName = (
      withdraw?.user_id?.lastName || ""
    ).toLowerCase();

    const fullName = `${firstName} ${lastName}`.toLowerCase();

    const mobile = String(
      withdraw?.user_id?.mobileNo ||
      withdraw?.mobile ||
      ""
    ).toLowerCase();

    const paymentMethod = String(
      withdraw?.payment_method || ""
    ).toLowerCase();

    const transactionId = String(
      withdraw?.transaction_id ||
      withdraw?.payout_transaction_id ||
      ""
    ).toLowerCase();

    const status = String(
      withdraw?.status || ""
    ).toLowerCase();

    const upiId = String(
      withdraw?.upi_id || ""
    ).toLowerCase();

    const amount = String(
      withdraw?.amount || ""
    ).toLowerCase();

    return (
      customerName.includes(search) ||
      fullName.includes(search) ||
      firstName.includes(search) ||
      lastName.includes(search) ||
      mobile.includes(search) ||
      paymentMethod.includes(search) ||
      transactionId.includes(search) ||
      status.includes(search) ||
      upiId.includes(search) ||
      amount.includes(search)
    );
  }) || [];
  const indexOfLastWithdraw = currentPage * usersPerPage;
const indexOfFirstWithdraw = indexOfLastWithdraw - usersPerPage;

const currentWithdrawals = filteredData.slice(
  indexOfFirstWithdraw,
  indexOfLastWithdraw
);
  const generateExcel = () => {
    
    const excelData = filteredData.map((withdraw) => ({
      'SNo': filteredData.indexOf(withdraw) + 1,
      'Customer Name': withdraw?.user_id?.name || withdraw?.upi_name || withdraw?.account_holder_name || '-',
      'Mobile': withdraw?.user_id?.mobileNo || '-',
      'Payment Method': withdraw?.payment_method || '-',
      'Amount': withdraw?.amount || 0,
      'Transaction ID': withdraw?.transaction_id || '-',
      'UPI ID': withdraw?.upi_id || '-',
      'Status': withdraw?.status || 'Approved',
      'Date': formatDateTime(withdraw?.createdAt),
    }));

    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Approved Withdrawals');
    XLSX.writeFile(wb, 'approved_withdrawals.xlsx');
  };

  return (
    <>
      <div className="right_col" role="main">
        <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">
          <div className="my-auto">
            <h5 className="page-title fs-21 mb-1">
              Approved Vendor Withdrawal List <span className="badge bg-orange">{filteredData?.length || 0}</span>
            </h5>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Approved Vendor Withdrawal List
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
            {/* <Link className="round-add-btn" to="/create-event">
              <img src="img/plus.svg" alt="Add Event" />
            </Link> */}
            <button className="excel-btn" onClick={generateExcel}>
              <img src="img/excel.svg" alt="Download Excel" />
              Download
            </button>
          </div>
        </div>

        <div className="container-box px-0 pt-2">
          <div className="Tablesearch_design">
            <div className="row">
              <div className='col-md-6'>
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <input
                    type="search"
                    name="search"
                    placeholder="Search by Name, Mobile, Payment Method, Transaction ID"
                    className='form-control'
                    value={searchQuery}
             onChange={(e) => {
  setSearchQuery(e.target.value);
  setCurrentPage(1);
}}
                  />
                  <button className="search-btn">Search</button>
                </div>
              </div>
            </div>
          </div>

          <div className="container-box-inner table-reponsive-tabe">
            <table id="example" className="table table-striped" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Vendor Name</th>
                  <th>Mobile</th>
                  <th>Payment Method</th>
                  <th>Amount</th>
                  <th>Transaction ID</th>
                  <th>Status</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                   {currentWithdrawals?.map((withdraw, i) => (
                  <tr key={i}>
                     <td>{indexOfFirstWithdraw + i + 1}</td>
                   <td>{withdraw?.vendor_id?.name || ""}
                      </td>
                    <td>{withdraw?.user_id?.mobileNo || "N/A"}</td>
                    <td>{withdraw?.payment_method || "N/A"}</td>
                    <td>₹{withdraw?.amount || 0}</td>
                    <td>{withdraw?.transaction_id || "N/A"}</td>
                    <td>
                      <span className="badge bg-success">
                        {withdraw?.status || "Approved"}
                      </span>
                    </td>
                    <td>
                      <div className="action_toggle_outer">
                        <button className="action_toggle" onClick={() => toggleActionMenu(i)}>
                          <i className="fa fa-ellipsis-v" />
                        </button>
                        {activeIndex === i && (
                          <div className="action_toggle_content product-edit show d-block">
                            <ul className="list-unstyled">
                              <li>
                                <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                  <i className="fa fa-close" />
                                </button>
                              </li>
                              <li>
                                <button className="approve" style={{ backgroundColor: '#60B930' }} onClick={() => handleViewDetails(withdraw)}>  <FaRegEye /> View</button>
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="pagination">
  <ReactPaginate
    pageCount={Math.ceil(
      (filteredData?.length || 0) / usersPerPage
    )}
    pageRangeDisplayed={3}
    marginPagesDisplayed={1}
    onPageChange={(data) => {
      setCurrentPage(data.selected + 1);
    }}
    containerClassName="pagination"
    activeClassName="active"
    previousLabel="Previous"
    nextLabel="Next"
    breakLabel="..."
    breakClassName="break-me"
    pageLinkClassName="page-link"
    previousLinkClassName="page-link"
    nextLinkClassName="page-link"
    pageClassName="page-item"
    previousClassName="page-item"
    nextClassName="page-item"
    disabledClassName="disabled"
    forcePage={currentPage - 1}
  />
</div>
          </div>
        </div>
      </div>
    </>
  );
}

export default VendorApproveWithdrawList;